import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");
    if (sessionId) {
      processGoogleSession(sessionId)
        .then(() => { window.history.replaceState(null, "", "/"); navigate("/", { replace: true }); })
        .catch(() => navigate("/login", { replace: true }));
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, processGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sky-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-cyan-600 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-slate-600 font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
